import React from 'react';

const ToastAlertView = ({ message }) => {
    return (
        <div
            style={{
                width: '100%',
                textAlign: 'left'
            }}
        >
                <span
                    style={{
                        color: '#757575',
                        fontSize: '14px'
                    }}
                >
                    {message}
                </span>
        </div>
    );
};

export default ToastAlertView;